export default __webpack_public_path__ + "static/media/Asma_SR.f61a11d5.jpeg";